var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoIconColored = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFE424",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E429",
    offset: 0.19789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D559",
    offset: 0.19791
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D459",
    offset: 0.39981
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C787",
    offset: 0.39983
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C788",
    offset: 0.60108
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBB2",
    offset: 0.60187
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BBB2",
    offset: 0.79872
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DADE0",
    offset: 0.79993
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DADE2",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3705 -1800)",
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3413 1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306 250c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14zm0 2.8c-6.1856 0-11.2 5.0144-11.2 11.2s5.0144 11.2 11.2 11.2 11.2-5.0144 11.2-11.2-5.0144-11.2-11.2-11.2zm0 2.8c4.6392 0 8.4 3.7608 8.4 8.4s-3.7608 8.4-8.4 8.4-8.4-3.7608-8.4-8.4 3.7608-8.4 8.4-8.4zm-3.3501 1.6531c-1.3543 0.75418-2.424 1.939-3.0131 3.3633l3.4464 0.83888c0.32265-0.54274 0.79493-0.99032 1.3618-1.289zm3.4475-0.88951c-0.94354 0-1.8432 0.18305-2.6638 0.51472l1.8356 2.9785c0.26546-0.063181 0.54284-0.096677 0.82824-0.096677 0.62553 0 1.2125 0.1609 1.719 0.44339l2.0022-2.7898c-1.0764-0.6651-2.3527-1.0501-3.7212-1.0501z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoIconColored);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-icon-colored.1306aa9a0549202b61824f27dbe95242.svg";